// Navigation.jsx
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom'; // 'useLocation' hook provides the current URL pathname, which can be used to determine the active menu dynamically.
import './NavBar.css';
// import chm_logo from '../assets/CHM-logo.png';
import chm_logo from '../assets/Artboard 1Bonus.png'; //updated logo
import globalVariables from "../custom_libraries/globalVariables";
import urls from '../custom_libraries/urls';
import ProfileIcon from '../assets/icons8-user-profile-32.png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "../assets/icons8-home-48.png";
import DeviceManagerIcon from "../assets/icons8-networking-manager-48.png";
import MapMarkerIcon from "../assets/icons8-map-marker-30.png";
import SettingsIcon from "../assets/icons8-settings-32.png";
import CctvIcon from "../assets/icons8-cctv-50.png";
import AnalyticsIcon from "../assets/icons8-combo-chart-50.png"
import LogoutIcon from "../assets/icons8-logout-64.png";
import HamburgerIcon from "../assets/icons8-fries-menu-48.png";
// import UserAccounts from "./Settings/UserAccounts";
import UserSettingsIcon from "../assets/icons8-management-48.png";
import '../Pages/Settings/SubNavbar.css';
// import AlertTabIcon from '../assets/icons8-alert-error-64.png';
import { signOut } from "../custom_libraries/auth";
import withNavigate from '../Global_files/WithNavigate'; 

const Navigation = ({ navigate }) => {
  const location = useLocation();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [formData, setFormData] = useState({
                                            first_name: '',
                                            last_name: '',
                                            phoneno: '',
                                            email: '',
                                          });
  const[successRes, setSuccessRes] = useState(false)
  const[errorRes, setErrorRes] = useState(false)
  const [userType, setUserType] = useState('');
  const [activeSubTab, setActiveSubTab] = useState("Add User");


  useEffect(() => {
    // Retrieve the user type from localStorage
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    setUserType(storedUserType);

    if (successRes || errorRes) {
      const timer = setTimeout(() => {
        setSuccessRes(false);
        setErrorRes(false);
      }, 2400); // 2 seconds

      // Cleanup the timer when the component unmounts or dependencies change
      return () => clearTimeout(timer);
    }
  }, [successRes, errorRes]); // Dependencies: triggers when `Success` or `error` changes


  // Fetch user profile details
  const fetchUserProfile = async (id) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const response = await fetch(urls.GET_PROFILE_DETAILS(id), {
        headers: headers,
    }); // Replace with actual URL
      console.log("respp--------", response);
      const data = await response.json();
      const userData = data.data;
      setFormData({
        first_name: userData.first_name,
        last_name: userData.last_name,
        phoneno: userData.phoneno,
        email: userData.email,
      });
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };


  // Fetch user profile details
  const UpdateUserProfile = async (id, updatedData) => {
    try {
      const url = `${urls.UPDATE_PROFILE_DETAILS(id)}`;
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`, // Optional if needed
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        throw new Error('Failed to update profile');
      }

      const data = await response.json();
      console.log('Profile updated successfully:', data);
      if(data && data.detail){
        setSuccessRes(true);
        setTimeout(() => {
          handleDialogToggle();
        }, 2500); // 2 seconds
        
      }
      else{
        setErrorRes(false);
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  };


  const handleDialogToggle = () => {
    const id = localStorage.getItem(globalVariables.USER_ID);

    setIsDialogOpen((prev) => !prev);
    if (id) {
      fetchUserProfile(id); // Pass the id to the fetchUserProfile function
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    const id = localStorage.getItem(globalVariables.USER_ID);
    if (id) {
      UpdateUserProfile(id, formData); // Send updated form data to the server
    }
    // Add form submission logic here
  };

  
  // const isActive = (path) => location.pathname === path;
  const handleLogout = () => {
    // Perform clearing localStorage/sessionStorage.
    
    signOut(navigate);
    localStorage.removeItem(globalVariables.AUTH_TOKEN); // Example
    console.log("User logged out from:", location.pathname);
  };


  // Updated isActive function
  const isActive = (path) => location.pathname.startsWith(path);

  // Toggle the sidebar collapse state.
  const toggleNavbar = () => {
    setIsCollapsed((prevState) => {
      console.log("Toggling navbar:", !prevState);
      return !prevState;
    });
  };
   

  let user_name = localStorage.getItem(globalVariables.USER_NAME);
  return (
    <div className={`navbar-container ${isCollapsed ? "collapsed" : ""}`}>
    <nav className="navbar" >
        <span style={{ display: 'flex', alignItems: 'center', justifyContent:'center'}}>
            <img src={chm_logo} alt="logo" width={70} height={60} />
            {/* <img src={HamburgerIcon} alt="toggle-navbar" width="30px" className="toggle-button" onClick={toggleNavbar}/> */}
        </span>
            <>
            <span>
              <ul>
              {/* DealerUser: Access to all tabs */}
              {(userType === 'DealerUser' || userType === 'CustomerUser' || userType === 'TechnicianUser') && (
                  <li className={isActive('/system-overview') ? 'active' : ''}>
                    <Link to="/system-overview" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={HomeIcon} alt='home-icon' width="31px"/>
                      <span>System<br/> Overview</span>
                      {/* <span>Overview</span> */}
                    </Link>
                  </li>
              )}
              
              {(userType === 'DealerUser' || userType === 'TechnicianUser') && (
                <>
                  <li className={isActive('/showDevices') ? 'active' : ''}>
                    <Link to="/showDevices" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={CctvIcon} alt='map-marker' width="31px"/>
                      <span>Sites</span>
                    </Link>
                  </li>

                  {/* <li className={isActive('/alerts') ? 'active' : ''}>
                  <Link to="/alerts" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                    <img src={AlertTabIcon} alt='map-marker' width="31px"/>
                    <span>Alerts</span>
                  </Link>
                  </li> */}

                  <li className={isActive('/analytics') ? 'active' : ''}>
                  <Link to="/analytics" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                    <img src={AnalyticsIcon} alt='map-marker' width="31px"/>
                    <span>Analytics</span>
                  </Link>
                  </li>
                </>
              )}
              {(userType === 'DealerUser'|| userType === 'CustomerUser') && (
                <>
                  <li className={isActive('/settings') ? 'active' : ''} onClick={() => setActiveSubTab("Schedule Time")}>
                    <Link to="/settings" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={SettingsIcon} alt='setting-icon' width="31px" />
                      <span>Settings</span>
                    </Link>
                  </li>
                </> 
              )} 
              {userType === "DealerUser" && (
                  <>
                    <li className={isActive("/userAccounts") ? "active" : ""} onClick={() => setActiveSubTab("Add User")}>
                      <Link to="/userAccounts" style={{ display: "flex", flexDirection:'column', alignItems: "center" }}>
                        <img src={UserSettingsIcon} alt="setting-icon" width="31px" />
                        <span>User<br/>Management</span>
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </span>
              <div className="user-info" >
                <div onClick={handleDialogToggle}>
                  <span style={{ display: 'flex', alignItems: 'center', flexDirection:'column', cursor:'pointer' }}>
                    <img src={ProfileIcon} alt="profile-icon" width="33px" />
                    <span style={{color: 'rgb(41, 223, 255)', fontSize:'18px'}}>{user_name}</span>
                  </span>
                </div><br/>

                <div style={{display: 'flex', alignItems: "center", flexDirection:'column'}}>
                  {/* <Link to="/" style={{ textDecoration: "none" }}> */}
                  <img src={LogoutIcon} alt='logouticon' width='31px' onClick={handleLogout} style={{cursor:'pointer'}}></img>
                  {/* </Link> */}
                  <span>Logout</span>
                </div>
              </div>
          </>


        {/* Dialog Box */}
      {isDialogOpen && (
        <div
          style={{
            position: 'fixed',  // Use fixed to position it relative to the viewport
            top: '0',           // Align to the top
            right: '0',         // Align to the extreme right
            backgroundColor: 'white',
            padding: '0px 15px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: '1000',
            color: 'black',
            width: '234px',
            height: '100vh',  // Full height to cover the right side
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // justifyContent: 'center'
          }}
        >
          <span style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', color:'#1c5a90'}}>
            <img src={ProfileIcon} alt='profile-icon' width="40px" height="40px"/>
            <h3>Update Profile</h3>
          </span>
          <form onSubmit={handleSubmit} style={{width:'100%', padding:'2px', display:'flex', flexDirection: 'column', gap:'8px'}}>
            {/* <div style={{display:'flex', justifyContent:'center', gap:'5px'}}> */}
            {successRes && (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                    Profile update is successful.
                </Alert>
            )}
            {errorRes && (
                <Alert severity="error">
                    Server Error! Profile was not updated.
                </Alert>
            )}
            <div>
              <label style={{color:'#1c5a90'}}>First Name:</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleInputChange}
                style={{width:'90%', height:'20px', fontSize:'14px'}}
                required
              />
            </div>
            <div>
              <label style={{color:'#1c5a90'}}>Last Name:</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                style={{width:'90%', height:'20px', fontSize:'14px'}}
                required
              />
            </div>
            <div>
              <label style={{color:'#1c5a90'}}>Phone No:</label>
              <input
                type="text"
                name="phoneno"
                value={formData.phoneno}
                onChange={handleInputChange}
                style={{width:'90%', height:'20px', fontSize:'14px'}}
                required
              />
            </div>
            <div>
              <label style={{color:'#1c5a90'}}>Email Id:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                style={{width:'90%', height:'20px', fontSize:'14px'}}
                required
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button type="submit" style={{ color:'#0ab58a', height:'20px'}}>Submit</Button>
              <Button
                type="button"
                style={{ marginLeft: '10px', color:'red', border:'none', height:'20px'}}
                onClick={handleDialogToggle}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      )}

      {/* Overlay (optional) */}
      {isDialogOpen && (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: '900',
          }}
          onClick={handleDialogToggle}
        ></div>
      )}
    </nav>
    
    </div>
  );
};

export default withNavigate(Navigation);
